import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class GuestOverlay extends Vue {
  @Prop({ required: true }) readonly isGuest!: boolean;
}
